/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { V3Service } from "./V3Service";
import { v3Service } from "./V3Service";
export type Services = {
    v3: V3Service;
};
export const services = {
    v3: v3Service
} as const;
